import { type ReactNode, useState } from "react"
import { LoginModal } from "@/features/auth/components/LoginModal"

interface GuestActionProps {
  children: ReactNode
}

export function GuestAction({ children }: GuestActionProps) {
  const [showLoginModal, setShowLoginModal] = useState(false)

  return (
    <>
      <div
        role="button"
        tabIndex={0}
        onClick={e => {
          e.preventDefault()
          e.stopPropagation()
          setShowLoginModal(true)
        }}
        onKeyDown={e => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault()
            e.stopPropagation()
            setShowLoginModal(true)
          }
        }}
        className="cursor-pointer"
      >
        {children}
      </div>
      <LoginModal open={showLoginModal} onOpenChange={setShowLoginModal} />
    </>
  )
}
